function Maintenance() {
    return (
        <div style={{ textAlign: 'center', padding: '50px', color: "#8b2881" , margin : 'auto'}} >
            <img src="logo.jpeg" alt="logo" id='logo' height={100} width={100} />
            <h1>الموقع تحت الصيانة</h1>
            {/* <p>نعتذر عن الإزعاج، نحن نقوم بأعمال الصيانة اللازمة. يرجى المحاولة لاحقًا.</p> */}
            <p>لا يوجد رصيد حاليا سيتم إعلامكم عندما يتوفر رصيد</p>
        </div>
    );
}
export default Maintenance;